import type { MetaAdDraftStatus } from '../../types/metaAdDraft';

// Stage 7A D1 — pure publish-button gating. Returns the human-readable reason the
// Publish button is disabled, or null when it's enabled. D1 renders this; D3 wires
// the actual publish call. Priority: already-published → blocking errors → reach
// estimate still calculating (don't let an AM publish mid-estimate).
export function publishDisabledReason(opts: {
  draftStatus: MetaAdDraftStatus;
  validationOk: boolean;
  errorCount: number;
  reachLoading: boolean;
}): string | null {
  if (opts.draftStatus !== 'draft') return 'This draft can no longer be published.';
  if (!opts.validationOk) {
    return `Resolve ${opts.errorCount} error${opts.errorCount === 1 ? '' : 's'} below`;
  }
  if (opts.reachLoading) return 'Publish blocked: reach estimate is still calculating';
  return null;
}
